<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import ItineraryDayProgramLocationModal from '../../components/itinerary/ItineraryDayProgramLocationModal.vue';
import ItineraryDayProgramList from '../../components/itinerary/ItineraryDayProgramList.vue';
import ItineraryDayProgramHotelModal from '../../components/itinerary/ItineraryDayProgramHotelModal.vue';
import ItineraryDayProgramExtraModal from '../../components/itinerary/ItineraryDayProgramExtraModal.vue';
import ItineraryDayProgramGolfModal from '../../components/itinerary/ItineraryDayProgramGolfModal.vue';
import ItineraryDayProgramMealPlanModal from '../../components/itinerary/ItineraryDayProgramMealPlanModal.vue';
import ItineraryDayProgramImageModal from '../../components/itinerary/ItineraryDayProgramImageModal.vue';
import ItineraryDayProgramDeleteModal from '../../components/itinerary/ItineraryDayProgramDeleteModal.vue';
import ItineraryDayProgramCopyModal from '../../components/itinerary/ItineraryDayProgramCopyModal.vue';
import ItineraryDayProgramDayTextModal from '../../components/itinerary/ItineraryDayProgramDayTextModal.vue';
import dayProgramHotels from '../../utils/dayProgramHotels';

export default {
  name: 'ItineraryEditDayProgram',
  components: {
    ItineraryDayProgramDeleteModal,
    ItineraryDayProgramLocationModal,
    ItineraryDayProgramList,
    ItineraryDayProgramHotelModal,
    ItineraryDayProgramExtraModal,
    ItineraryDayProgramGolfModal,
    ItineraryDayProgramMealPlanModal,
    ItineraryDayProgramImageModal,
    ItineraryDayProgramCopyModal,
    ItineraryDayProgramDayTextModal,
  },
  data() {
    return {
      itineraryId: null,
      dayProgramEntry: null,
      dayProgramEntryId: null,
      showLocationModal: false,
      showHotelModal: false,
      showExtraModal: false,
      showGolfModal: false,
      showMealPlanModal: false,
      showImageModal: false,
      showDayProgramDeleteModal: false,
      showDayProgramCopyModal: false,
      showDayProgramDayTextModal: false,
    };
  },
  computed: {
    ...mapState({
      dayProgramLoading: state => state.itinerary.dayProgram.loading,
      dayProgramError: state => state.itinerary.dayProgram.error,
      dayProgramItems: state => state.itinerary.dayProgram.items,
      countriesAndAreasItems: state => state.itinerary.masterCountries.items,
      locationDayProgram: state => state.itinerary.dayProgramLocation.dayProgram,
      locationDayProgramSaveLoading: state => state.itinerary.dayProgramLocation.loading,
      hotelDayProgramLoading: state => state.itinerary.dayProgramHotel.loading,
      hotelDayProgram: state => state.itinerary.dayProgramHotel.dayProgram,
      selectedHotels: state => state.itinerary.dayProgramHotel.selectedHotels,
      extraDayProgramLoading: state => state.itinerary.dayProgramExtras.loading,
      extraDayProgram: state => state.itinerary.dayProgramExtras.dayProgram,
      dayProgramExtras: state => state.itinerary.dayProgramExtras.extras,
      mealPlanTypes: state => state.itinerary.mealPlanTypes.types,
      mealPlanOptions: state => state.itinerary.mealPlanTypes.options,
      mealPlanDayProgram: state => state.itinerary.dayProgramMealPlans.dayProgram,
      dayProgramMealPlans: state => state.itinerary.dayProgramMealPlans.mealPlans,
      mealPlanDayProgramLoading: state => state.itinerary.dayProgramMealPlans.loading,
      selectedDomain: state => state.itinerary.domains.selected,
      dayProgramImagesLoading: state => state.itinerary.dayProgramImages.loading,
      dayProgramImages: state => state.itinerary.dayProgramImages.items,
      itinerary: state => state.itinerary.edit.item,
    }),
    ...mapGetters({
      getAvailableDayProgramHotels: 'itinerary/getAvailableDayProgramHotels',
    }),
  },
  methods: {
    ...mapActions({
      getDayProgram: 'itinerary/getDayProgram',
      getMealPlanTypes: 'itinerary/getMealPlanTypes',
      addDayProgramEntry: 'itinerary/addDayProgramEntry',
      deleteDayProgramEntry: 'itinerary/deleteDayProgramEntry',
      updateDayProgram: 'itinerary/updateDayProgram',
      duplicateDayProgramEntry: 'itinerary/duplicateDayProgramEntry',
      getCountriesWithAreasByProductTypeId: 'itinerary/getCountriesWithAreasByProductTypeId',
      setLocationDayProgram: 'itinerary/setLocationDayProgram',
      updateDayProgramLocation: 'itinerary/updateDayProgramLocation',
      fetchDayProgramHotelData: 'itinerary/fetchDayProgramHotelData',
      updateDayProgramSites: 'itinerary/updateDayProgramSites',
      fetchDayProgramExtraData: 'itinerary/fetchDayProgramExtraData',
      updateDayProgramExtras: 'itinerary/updateDayProgramExtras',
      updateDayProgramExtraAdditionals: 'itinerary/updateDayProgramExtraAdditionals',
      getDayProgramMealPlans: 'itinerary/getDayProgramMealPlans',
      updateDayProgramMealPlans: 'itinerary/updateDayProgramMealPlans',
      updateItineraryDomains: 'itinerary/updateItineraryDomains',
      getItineraryDayProgramImages: 'itinerary/getItineraryDayProgramImages',
      uploadItineraryDayProgramImages: 'itinerary/uploadItineraryDayProgramImages',
      updateItineraryDayProgramImages: 'itinerary/updateItineraryDayProgramImages',
      deleteItineraryDayProgramImage: 'itinerary/deleteItineraryDayProgramImage',
    }),
    ...mapMutations({
      setAvailableExtras: 'itinerary/ITINERARY_DAY_PROGRAM_SET_AVAILABLE_EXTRAS',
    }),
    openDayProgramDeleteModal(dayProgramEntryId) {
      this.dayProgramEntryId = dayProgramEntryId;
      this.showDayProgramDeleteModal = true;
    },
    openDayProgramCopyModal(dayProgramEntry) {
      this.dayProgramEntry = dayProgramEntry;
      this.showDayProgramCopyModal = true;
    },
    openDayProgramLocationModal(event) {
      this.setLocationDayProgram(event).then(() => {
        this.showLocationModal = true;
      });
    },
    openDayProgramHotelModal(data) {
      this.showHotelModal = true;
      this.fetchDayProgramHotelData({
        itineraryId: this.itineraryId,
        data,
      });
    },
    openDayProgramExtraModal(data) {
      this.showExtraModal = true;
      this.fetchDayProgramExtraData({
        itineraryId: this.itineraryId,
        data,
      });
    },
    openDayProgramGolfModal(data) {
      this.showGolfModal = true;
      this.fetchDayProgramExtraData({
        itineraryId: this.itineraryId,
        data,
      });
    },
    openDayProgramMealPlanModal(data) {
      this.showMealPlanModal = true;
      this.getDayProgramMealPlans({
        itineraryId: this.itineraryId,
        data,
      });
    },
    openDayProgramImageModal(data) {
      this.showImageModal = true;
      this.dayProgramId = data.id;
      this.getItineraryDayProgramImages({
        dayProgramId: data.id,
      });
    },
    openDayProgramDayTextModal(dayProgramEntry) {
      this.dayProgramEntry = dayProgramEntry;
      this.showDayProgramDayTextModal = true;
    },
    saveDayProgram(data) {
      const payload = {
        itineraryId: this.itineraryId,
        data,
      };
      this.updateDayProgram(payload);
    },
    duplicateDayProgram(data) {
      const payload = {
        itineraryId: this.itineraryId,
        dayProgramEntryId: data.id,
      };
      this.duplicateDayProgramEntry(payload);
    },
    saveDayProgramLocation(data) {
      const payload = { itineraryId: this.itineraryId, data };
      const foundDayProgram = this.dayProgramItems.find(dayProgram => dayProgram.id === data.dayProgramId);
      const indexOfDayProgram = this.dayProgramItems.indexOf(foundDayProgram);

      this.updateDayProgramLocation(payload).then(() => {
        this.showLocationModal = false;
      }).catch();

      if (indexOfDayProgram > 0) {
        if (this.dayProgramItems[indexOfDayProgram - 1].areaId === data.areaId
          && this.dayProgramItems[indexOfDayProgram - 1].countryId === data.countryId) {
          const siteIds = this.dayProgramItems[indexOfDayProgram - 1].hotels.map(hotel => hotel.siteId);
          const hotelPayload = { dayProgramId: data.dayProgramId, itineraryId: this.itineraryId, siteIds };
          this.saveDayProgramHotels(hotelPayload);
        }
      }
    },
    saveDayProgramHotels(data) {
      const payloads = dayProgramHotels
        .getPropagationTargetIds(this.dayProgramItems, data.dayProgramId)
        .map(dayProgramId => ({ dayProgramId, itineraryId: this.itineraryId, siteIds: data.siteIds }));

      payloads.forEach(payload => {
        this.updateDayProgramSites(payload).then(() => {
          this.showHotelModal = false;
        }).catch();
      });

      this.updateDayProgramSites(data).then(() => {
        this.showHotelModal = false;
      }).catch().finally(() => {
        window.location.reload();
      });
    },
    saveDayProgramExtras(data) {
      this.updateDayProgramExtras(data).then(() => {
        this.showExtraModal = false;
      }).catch().finally(() => {
        window.location.reload();
      });
    },
    saveDayProgramExtraAdditionals(data) {
      this.updateDayProgramExtraAdditionals(data).then(() => {
        this.showGolfModal = false;
        window.location.reload();
      });
    },
    saveDayProgramMealPlans(data) {
      this.updateDayProgramMealPlans(data).then(() => {
        this.showMealPlanModal = false;
      }).catch().finally(() => {
        window.location.reload();
      });
    },
    updateItineraryDomain(event) {
      this.updateItineraryDomains({
        itineraryId: this.$route.params.id,
        itineraryDomains: [ event ],
      });
    },
    deleteDay(event) {
      this.deleteDayProgramEntry(event);
      this.showDayProgramDeleteModal = false;
    },
  },
  created() {
    this.itineraryId = parseInt(this.$route.params.id, 10);
    this.getDayProgram(this.itineraryId);
    this.getCountriesWithAreasByProductTypeId(this.itinerary.productTypeId);
    this.getMealPlanTypes();
  },
};
</script>

<template>
  <div>
    <itinerary-day-program-list
      :itinerary-id="itineraryId"
      :day-program-loading="dayProgramLoading"
      :day-program-error="dayProgramError"
      :day-program-items="dayProgramItems"
      :selected-domain="selectedDomain"
      :domains="itinerary.domains"
      @addDayProgramEntry="addDayProgramEntry"
      @deleteDayProgramEntry="openDayProgramDeleteModal"
      @copyDayProgramEntry="openDayProgramCopyModal"
      @saveDayProgram="saveDayProgram"
      @openLocationModal="openDayProgramLocationModal"
      @openHotelModal="openDayProgramHotelModal"
      @openExtraModal="openDayProgramExtraModal"
      @openGolfModal="openDayProgramGolfModal"
      @openMealPlanModal="openDayProgramMealPlanModal"
      @openImageModal="openDayProgramImageModal"
      @openDayTextModal="openDayProgramDayTextModal"
      @updateDomain="updateItineraryDomain"
      @duplicateDayProgramEntry="duplicateDayProgram"
    />
    <itinerary-day-program-location-modal
      v-if="showLocationModal && locationDayProgram"
      :countries-and-areas="countriesAndAreasItems"
      :day-program="locationDayProgram"
      :day-program-save-loading="locationDayProgramSaveLoading"
      @cancel="showLocationModal = false"
      @saveDayProgramLocation="saveDayProgramLocation"
    />
    <itinerary-day-program-hotel-modal
      v-if="showHotelModal"
      :itinerary-id="itineraryId"
      :loading="hotelDayProgramLoading"
      :day-program="hotelDayProgram"
      :available-hotels="getAvailableDayProgramHotels"
      :selected-hotels="selectedHotels"
      @cancel="showHotelModal = false"
      @update="saveDayProgramHotels"
    />
    <itinerary-day-program-delete-modal
      v-if="showDayProgramDeleteModal"
      :itinerary-id="itineraryId"
      :day-program-entry-id="dayProgramEntryId"
      @deleteDayProgramEntry="deleteDay"
      @close="showDayProgramDeleteModal = false"
    />
    <itinerary-day-program-copy-modal
      v-if="showDayProgramCopyModal"
      :itinerary-id="itineraryId"
      :day-program-entry="dayProgramEntry"
      @close="showDayProgramCopyModal = false"
    />
    <itinerary-day-program-day-text-modal
      v-if="showDayProgramDayTextModal"
      :itinerary-id="itineraryId"
      :day-program-entry="dayProgramEntry"
      @close="showDayProgramDayTextModal = false"
    />
    <itinerary-day-program-extra-modal
      v-if="showExtraModal"
      :loading="extraDayProgramLoading"
      :day-program="extraDayProgram"
      :available-extras="dayProgramExtras"
      :countries-and-areas="countriesAndAreasItems"
      :itinerary-id="itineraryId"
      @update="saveDayProgramExtras"
      @cancel="showExtraModal = false"
    />
    <itinerary-day-program-golf-modal
      v-if="showGolfModal"
      :loading="extraDayProgramLoading"
      :day-program-items="dayProgramItems"
      :available-extras="dayProgramExtras"
      :countries-and-areas="countriesAndAreasItems"
      :itinerary-id="itineraryId"
      @update="saveDayProgramExtraAdditionals"
      @cancel="showGolfModal = false"
    />
    <itinerary-day-program-image-modal
      v-if="showImageModal"
      :loading="dayProgramImagesLoading"
      :images="dayProgramImages"
      :day-program-id="dayProgramId"
      @upload="uploadItineraryDayProgramImages"
      @update="updateItineraryDayProgramImages"
      @close="showImageModal = false"
      @remove="deleteItineraryDayProgramImage"
    />
    <itinerary-day-program-meal-plan-modal
      v-if="showMealPlanModal"
      :itinerary-id="itineraryId"
      :loading="mealPlanDayProgramLoading"
      :day-program="mealPlanDayProgram"
      :meal-plan-mappings="dayProgramMealPlans"
      :meal-plan-types="mealPlanTypes"
      :meal-plan-options="mealPlanOptions"
      @update="saveDayProgramMealPlans"
      @cancel="showMealPlanModal = false"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryEditDayProgram.vue